import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material'
import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import ResponsiveAppBar from 'src/common/ResponsiveAppBar'
import { processBulkAction } from 'src/services/WorkflowService'
import { BulkActionItem } from 'src/viewModels/workflow/BulkActionItem'
import { BulkActionResult } from 'src/viewModels/workflow/BulkActionResult'
import { InboxActionSummary } from 'src/viewModels/workflow/InboxActionSummary'
import { ObjectiveBulkProcessAction } from 'src/viewModels/workflow/ObjectiveBulkProcessAction'
import BulkActionResultDisplay from './BulkActionResultDisplay'

interface IBulkStandardCommentModalProps {
  onClose: (closeNoActionExecuted: boolean) => void
  isOpen: boolean
  inboxItems: Array<BulkActionItem>
  inboxId: string
  action: InboxActionSummary
}

function BulkStandardCommentModal(props: IBulkStandardCommentModalProps) {
  const [executed, setExecuted] = useState(false)
  const [executingBulkAction, setExecutingBulkAction] = useState(false)
  const [results, setResults] = useState(new Array<BulkActionResult>())

  async function processAction(comments: string) {
    const action = props.action
    const data = new ObjectiveBulkProcessAction()
    data.comment = comments
    data.bulkInboxItems = props.inboxItems
    setExecutingBulkAction(true)

    try {
      const response = await processBulkAction(data, action.id.toString())
      setResults(response)
      setExecutingBulkAction(false)
      setExecuted(true)
    } catch (error) {
      setExecutingBulkAction(false)
    }
  }

  const handlesOnClose = () => {
    props.onClose(executed)
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={props.isOpen!}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          handlesOnClose()
        }
      }}
    >
      <DialogTitle style={{ padding: 0 }}>
        <ResponsiveAppBar title={props.action.actionName} isModal={true} />
      </DialogTitle>
      <DialogContent style={{ padding: '12px 12px 8px' }}>
        {executingBulkAction && (
          <div
            style={{
              position: 'fixed',
              display: 'flex',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              cursor: 'pointer',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: '1200',
            }}
          >
            <CircularProgress size={100} />
          </div>
        )}
        <Formik
          initialValues={{
            comments: '',
            requireComment: props.action.requireComment,
          }}
          onSubmit={() => {}}
        >
          {({ values, handleChange }) => (
            <Form>
              {!executed && (
                <Grid container direction="column" spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      label="Comments"
                      name="comments"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      required={props.action.requireComment}
                      fullWidth
                      multiline
                      minRows="4"
                      value={values.comments}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>
              )}
              {executed && !executingBulkAction && (
                <Grid container direction="column" spacing={1}>
                  <Grid item xs={12}>
                    <BulkActionResultDisplay results={results} />
                  </Grid>
                </Grid>
              )}
              <DialogActions>
                {!executed && (
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginLeft: '4px' }}
                    disabled={
                      executed || (props.action.requireComment && values.comments === '')
                    }
                    onClick={() => {
                      processAction(values.comments)
                    }}
                  >
                    Execute
                  </Button>
                )}
                <Button onClick={handlesOnClose} data-cy="close">
                  Close
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default BulkStandardCommentModal
